import Sections from "components/Contractors/sections";
import styles from "./ContractorFiles.module.css";
import {FilesPreviewDialog} from "components/Shared/FilesPreviewDialog";
import {downloadContractorFile, getContractorFile} from "services";
import {FileChip} from "components/Shared/FileChip";
import {DetailsColumn} from "components/Shared/CrudComponents";
import React, {useMemo} from "react";
import {useContractorFilePreview} from "./useContractorFilePreview";

export const ContractorFiles = ({contractor, previousContractor, ...columnProps}) => {
    const chips = useMemo(() => {
        if (previousContractor) {
            const currFileIds = contractor.files.map(f => f.id)
            const prevFileIds = previousContractor.files.map(f => f.id)

            const newFiles = contractor.files.filter(f => !prevFileIds.includes(f.id))
                .map(file => ({
                    file, containerClassName: styles.newFile
                }))
            const removedFiles = previousContractor.files.filter(f => !currFileIds.includes(f.id))
                .map(file => ({
                    file, containerClassName: styles.removedFile
                }))
            const unchangedFiles = contractor.files.filter(f => prevFileIds.includes(f.id))
                .map(file => ({file}))

            return [...removedFiles, ...unchangedFiles, ...newFiles].sort(({file}) => file.addDateTime)
        }
        return contractor.files.map(file => ({file}))
    }, [contractor, previousContractor])

    const files = chips.map(({file}) => file)

    const {previewedFile, handlePreviewFileChange, handleFilePreviewClose} = useContractorFilePreview(files)

    return (
        <DetailsColumn section={Sections.Files} {...columnProps}>
            <div className={styles.files}>
                <FilesPreviewDialog open={!!previewedFile}
                                    fileToShow={previewedFile}
                                    filesSource={getContractorFile}
                                    files={files}
                                    onClose={handleFilePreviewClose}
                                    onFileChanged={handlePreviewFileChange}
                />
                <ul className="d-flex flex-column p-0">
                    {chips.map(({file, containerClassName}) => (
                        <FileChip
                            key={file.id}
                            file={file}
                            maxTextLength={30}
                            onDownload={() => downloadContractorFile(file)}
                            onShow={handlePreviewFileChange}
                            classes={{chipContainer: containerClassName}}
                        />
                    ))}
                </ul>
            </div>
        </DetailsColumn>
    )
}